<template>
  <router-view />
  <!-- <div v-if="showCookieBanner" class="cookie-banner">
    <p>我们使用 Cookie 来提升您的浏览体验。<a href="/privacy-policy">了解更多</a></p>
    <button @click="acceptCookies">同意</button>
    <button @click="declineCookies">拒绝</button>
  </div> -->
</template>

<script>
import { getCurrentInstance, onMounted, reactive ,ref} from 'vue'
import { useStore } from 'vuex';
export default {
  name: 'App',

  setup() {
    const store = useStore()
    const { proxy } = getCurrentInstance()
    const configInfo = reactive({ data: {} })
    // 获取系统配置信息
    const getSystemConfigInfo = () => {
      proxy.$get("v3/system/front/setting/getSettings", {
        names: "main_site_logo,main_user_center_logo,main_user_logon_bg,main_user_register_bg,pc_home_bottom_adv,main_user_forget_password_bg,basic_site_name,basic_site_icp,basic_site_copyright,basic_site_technical_support,platform_customer_service_name,platform_customer_service_logo,pc_browser_icon"
      }).then(res => {
        if (res.state == 200) {
          configInfo.data = {
            main_site_logo: res.data[0],
            main_user_center_logo: res.data[1],
            main_user_logon_bg: res.data[2],
            main_user_register_bg: res.data[3],
            pc_home_bottom_adv: res.data[4],
            main_user_forget_password_bg: res.data[5],
            basic_site_name: res.data[6],
            basic_site_icp: res.data[7],
            basic_site_copyright: res.data[8],
            basic_site_technical_support: res.data[9],
            platform_customer_service_name: res.data[10],
            platform_customer_service_logo: res.data[11]
          }
          store.commit('updateConfigInfo', configInfo.data);

            // var link = document.querySelector("link[rel*='icon']") ||  document.createElement('link');
            // link.type = 'image/x-icon';
            // link.rel = 'shortcut icon';
            // link.href = res.data[12]?res.data[12]:location.origin+'/favicon.ico';
            // document.getElementsByTagName('head')[0].appendChild(link);
        }
      })
    };

    // const showCookieBanner = ref(false);

    // const getCookie = (name) => {
    //   const cookieArr = document.cookie.split(';');
    //   for (let i = 0; i < cookieArr.length; i++) {
    //     const cookiePair = cookieArr[i].split('=');
    //     if (name === cookiePair[0].trim()) {
    //       return decodeURIComponent(cookiePair[1]);
    //     }
    //   }
    //   return null;
    // };

    // const acceptCookies = () => {
    //   document.cookie = 'cookie_consent=true; path=/; max-age=31536000';
    //   showCookieBanner.value = false;
    // };

    // const declineCookies = () => {
    //   document.cookie = 'cookie_consent=false; path=/; max-age=31536000';
    //   showCookieBanner.value = false;
    // };

    


    onMounted(() => {

      //debugger   // just for test

      getSystemConfigInfo()

      document.title = '华硕商城ASUS_华硕官网_华硕电脑官方直营商城，购笔记本电脑、轻薄本、游戏本、享一年意外险';
      // 如果 ASUS 的 Cookie 横幅被禁用，则显示自定义横幅
      // if (!window.AsusAPIConfig.isHasCookieBanner && !getCookie('cookie_consent')) {
      //   showCookieBanner.value = true;
      // }

    });

    // return {
    //   showCookieBanner,
    //   acceptCookies,
    //   declineCookies,
    //   getCookie,
    // };

  }

}
</script>

<style lang="scss">
@import "./style/reset.scss";
@import "./style/base.scss";

//放大镜位置
.mouse-cover-canvas {
  position: absolute;
  top: 173px !important;
  left: 740px !important;
}

// :root {
//   --scale-factor: 0.8; /* 设置你想要的缩放比例 */
// }

// /* 应用到文本元素 */
// body, p, h1, h2, h3, h4, h5, h6, span, div, li, a {
//   font-size: calc(1rem * var(--scale-factor));
// }

// img {
//   width: calc(100% * var(--scale-factor));
//   height: auto; /* 保持图片宽高比 */
// }

// .el-checkbox {
//   .el-checkbox__input {

//     &.is-checked,
//     &.is-indeterminate {
//       .el-checkbox__inner {
//         border-color: var(--color_main);
//         background-color: var(--color_main);
//       }
//     }

//     &.is-focus {
//       .el-checkbox__inner {
//         border-color: var(--color_main);
//       }
//     }

//     .el-checkbox__inner {
//       &:hover {
//         border-color: var(--color_main);
//       }
//     }

//     &+.el-checkbox__label {
//       color: var(--color_main);
//     }
//   }
// }
</style>
